import { EffectCallback, DependencyList } from 'react'
import { useEffectWithCount } from './useEffectWithCount'

/**
 * Equal to useEffect, but skips first render. Equal to `componentDidUpdate`.
 */
export function useUpdate(effect: EffectCallback, deps?: DependencyList) {
  useEffectWithCount((i) => {
    if (i === 0) return
    return effect()
  }, deps)
}
